import React, { Fragment } from 'react'

import { RadioButtonIcon, RadioButtonHoverIcon, RadioButtonCheckedIcon } from '@wf-sl/common-icons'

import styles from './radio-button.module.css'

export function RadioButtonIcons() {
    return (
        <Fragment>
            <RadioButtonIcon className={styles['icon']} />
            <RadioButtonHoverIcon className={styles['icon-hover']} />
            <RadioButtonCheckedIcon className={styles['icon-checked']} />
        </Fragment>
    )
}
